/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_OptionalInputs */

const en_directory_ai_tools_studio_optional = /** @type {(inputs: Directory_Ai_Tools_Studio_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional`)
};

const zh_directory_ai_tools_studio_optional = /** @type {(inputs: Directory_Ai_Tools_Studio_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选填`)
};

/**
* | output |
* | --- |
* | "Optional" |
*
* @param {Directory_Ai_Tools_Studio_OptionalInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_optional = /** @type {((inputs?: Directory_Ai_Tools_Studio_OptionalInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_OptionalInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_optional(inputs)
	return zh_directory_ai_tools_studio_optional(inputs)
});
export { directory_ai_tools_studio_optional as "directory.ai_tools.studio.optional" }